"use client";

import { Heart } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { Button } from "@/components/ui/button";
import { GlassCard } from "@/components/glass-card";
import { LoginButton } from "@/app/[locale]/(auth)/signin/_components/login-button";

export function NoProjectSelected({ isLoggedOut }: { isLoggedOut?: boolean }) {
  const t = useTranslations("impact");

  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <GlassCard className="max-w-md text-center p-8">
        <Heart className="h-16 w-16 mx-auto mb-4 text-muted-foreground/40" />
        <h2 className="text-2xl font-bold mb-2">
          {t(isLoggedOut ? "noProject.loggedOut.title" : "noProject.title")}
        </h2>
        <p className="text-muted-foreground mb-6">
          {t(isLoggedOut ? "noProject.loggedOut.message" : "noProject.message")}
        </p>
        {isLoggedOut ? (
          <LoginButton size="lg">
            {t("noProject.loggedOut.registerButton")}
          </LoginButton>
        ) : (
          <Button asChild size="lg">
            <Link href="/projects">{t("noProject.selectButton")}</Link>
          </Button>
        )}
      </GlassCard>
    </div>
  );
}
